import axios from "axios";
import authHeader from '@/services/auth/AuthHeader';

const noCacheHeaders = () => ({
    ...authHeader(),
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
});

class AnalyticsService {
    getBusinessAnalytics(fromDate, toDate, locationId = null) {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/analytics/getBusinessAnalytics?merchant=' + user.merchant;
        if (fromDate) url += '&fromDate=' + fromDate;
        if (toDate) url += '&toDate=' + toDate;
        if (locationId && locationId !== 'ALL') url += '&locationId=' + locationId;
        return axios.get(url, { headers: noCacheHeaders() });
    }

    getProductPerformance(fromDate, toDate, locationId = null) {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/analytics/getProductPerformance?merchant=' + user.merchant;
        if (fromDate) url += '&fromDate=' + fromDate;
        if (toDate) url += '&toDate=' + toDate;
        if (locationId && locationId !== 'ALL') url += '&locationId=' + locationId;
        return axios.get(url, { headers: noCacheHeaders() });
    }

    getTimePatternsAnalytics(fromDate, toDate, locationId = null) {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/analytics/getTimePatterns?merchant=' + user.merchant;
        if (fromDate) url += '&fromDate=' + fromDate;
        if (toDate) url += '&toDate=' + toDate;
        if (locationId && locationId !== 'ALL') url += '&locationId=' + locationId;
        return axios.get(url, { headers: noCacheHeaders() });
    }

    getGrowthMetrics(locationId = null) {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/analytics/getGrowthMetrics?merchant=' + user.merchant;
        if (locationId && locationId !== 'ALL') url += '&locationId=' + locationId;
        return axios.get(url, { headers: noCacheHeaders() });
    }

    getCategoryAnalytics(fromDate, toDate, locationId = null) {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/analytics/getCategoryAnalytics?merchant=' + user.merchant;
        if (fromDate) url += '&fromDate=' + fromDate;
        if (toDate) url += '&toDate=' + toDate;
        if (locationId && locationId !== 'ALL') url += '&locationId=' + locationId;
        return axios.get(url, { headers: noCacheHeaders() });
    }

    getSalesByChannel(fromDate, toDate, locationId = null) {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/analytics/getSalesByChannel?merchant=' + user.merchant;
        if (fromDate) url += '&fromDate=' + fromDate;
        if (toDate) url += '&toDate=' + toDate;
        if (locationId && locationId !== 'ALL') url += '&locationId=' + locationId;
        return axios.get(url, { headers: noCacheHeaders() });
    }

    getSalesByPaymentMethod(fromDate, toDate, locationId = null) {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/analytics/getSalesByPaymentMethod?merchant=' + user.merchant;
        if (fromDate) url += '&fromDate=' + fromDate;
        if (toDate) url += '&toDate=' + toDate;
        if (locationId && locationId !== 'ALL') url += '&locationId=' + locationId;
        return axios.get(url, { headers: noCacheHeaders() });
    }
}

export default new AnalyticsService();
